import Vue from 'vue';
import Vuex from 'vuex';
import config from './modules/config';
import routerV from './modules/router';
import user from './modules/user';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    config,
    routerV,
    user
  }
});

export default store;
